import _ from 'lodash'
import termPath from '../Threshold/lib/termPath'

export default ({ formikProps: { values }, formikProps }) =>
  _.get(values, `${termPath({ formikProps })}.type`) === 'plain'
